export const LOCALSTORAGE_KEY = 'adminbase'
export const DEFAULT_FETCH_CUANTOS = 10

export const NO_AVATAR_IMAGE_URL = process.env.REACT_APP_API_URL + 'public/img/default_avatar.png'